var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';

const Tab = ({
  id,
  label,
  children




}) => /*#__PURE__*/
_jsx("div", { className: "hidden", id: id, "data-label": label }, void 0,
children
);








const Tabs = ({ children, onTabSelected, unmountTabs = true }) => {
  const [activeTab, setActiveTab] = useState(children[0].props.id);

  const handleClick = (
  e,
  newActiveTab) =>
  {
    e.preventDefault();
    setActiveTab(newActiveTab);

    if (onTabSelected) {
      onTabSelected(newActiveTab);
    }
  };

  const buttonClass = 'text-sm flex-1 font-medium py-2 w-80 h-14';
  const activeClass = 'text-gray-900 bg-gray-50';
  const inactiveClass = 'text-gray-500';

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx("div", {
      className: "flex rounded-md border border-gray-50 shadow-sm md:w-1/2",
      "data-testid": "tabs-comp" }, void 0,

    children.map((child, index) => /*#__PURE__*/
    _jsx("button", {

      type: "button",
      className: `${buttonClass} ${
      activeTab === child.props.id ? activeClass : inactiveClass} ${
      index !== children.length - 1 ? 'border-r-2 border-gray-50' : ''}`,
      onClick: (e) => handleClick(e, child.props.id) }, child.props.id,

    child.props.label
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "py-4 grow" }, void 0,
    children.map((child) => {
      if (unmountTabs) {
        if (child.props.id === activeTab) {
          return (/*#__PURE__*/
            _jsx("div", { className: "w-full h-full" }, child.props.id,
            child.props.children
            ));

        }
      }

      if (!unmountTabs) {
        return (/*#__PURE__*/
          _jsx("div", {

            className: `w-full h-full ${child.props.id !== activeTab ? 'hidden' : ''}` }, child.props.id,

          child.props.children
          ));

      }

      return null;
    })
    )
    ));

};

Tabs.Tab = Tab;



export { Tabs };